export function buildBemobiCheckoutIframeUrl(
  baseUrl: string,
  sessionToken: string
): string {
  const url = new URL(baseUrl);

  url.searchParams.set('code', sessionToken);

  return url.toString();
}
